import styled from "styled-components";

export const Actions = styled("div")`
  padding: 8px 16px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background-color: white;
  gap: 8px;
`;
